/* ARK Products — ブログ本文画像のライトボックス（enhancement）
   記事本文の画像クリックを横取りし、ページ内オーバーレイで拡大表示。
   <figure><a target="_blank"><img> の <a> があれば別タブ遷移を止めてライトボックス表示。
   ギャラリー(.ark-swiper)内の画像なら、その群を左右送りできる。
   JS 無効時は従来どおり <a target="_blank"> が働く（progressive enhancement）。 */
(function () {
  'use strict';

  var overlay = null;
  var imgEl = null;
  var items = [];
  var index = 0;
  var trigger = null;

  function isImageUrl(url) {
    return /\.(png|jpe?g|gif|webp|avif|svg)(\?|#|$)/i.test(url || '');
  }

  function focusable() {
    if (!overlay) return [];
    return Array.prototype.filter.call(overlay.querySelectorAll('button'), function (b) {
      return b.offsetParent !== null;
    });
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'ark-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', '画像の拡大表示');

    var close = btn('ark-lightbox__close', '×', '閉じる');
    var prev = btn('ark-lightbox__nav ark-lightbox__nav--prev', '‹', '前の画像');
    var next = btn('ark-lightbox__nav ark-lightbox__nav--next', '›', '次の画像');
    imgEl = document.createElement('img');
    imgEl.className = 'ark-lightbox__img';
    imgEl.alt = '';

    overlay.appendChild(close);
    overlay.appendChild(prev);
    overlay.appendChild(imgEl);
    overlay.appendChild(next);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeBox();
    });
    close.addEventListener('click', closeBox);
    prev.addEventListener('click', function (e) { e.stopPropagation(); show(index - 1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); show(index + 1); });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeBox();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });

    var sx = 0;
    overlay.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    // フォーカストラップ: Tab が背後へ抜けないようライトボックス内で循環
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = focusable();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function btn(cls, glyph, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-label', label);
    b.textContent = glyph;
    return b;
  }

  function openBox(list, i) {
    if (!overlay) build();
    trigger = document.activeElement;
    items = list;
    overlay.classList.toggle('ark-lightbox--single', items.length < 2);
    document.body.style.overflow = 'hidden';
    overlay.classList.add('is-open');
    show(i);
    var closeBtn = overlay.querySelector('.ark-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function show(i) {
    if (!items.length) return;
    if (i < 0) i = items.length - 1;
    if (i >= items.length) i = 0;
    index = i;
    imgEl.src = items[i].src;
    imgEl.alt = items[i].alt || '';
  }

  function closeBox() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
    trigger = null;
  }

  // クリック対象画像から、拡大用 URL（<a href> があればそれ、無ければ img.src）と alt を取る
  function toItem(img) {
    var a = img.closest('a');
    var href = a ? a.getAttribute('href') : null;
    return { src: href && isImageUrl(href) ? href : (img.currentSrc || img.src), alt: img.getAttribute('alt') || '' };
  }

  function init() {
    var content = document.querySelector('.article--content');
    if (!content) content = document.querySelector('.rte');
    if (!content) return;

    content.addEventListener('click', function (e) {
      var img = e.target.closest('img');
      if (!img || !content.contains(img)) return;

      // 画像が非画像リンク(商品ページ等)で囲まれている場合は横取りせず、そのまま遷移させる
      var a = img.closest('a');
      if (a) {
        var href = a.getAttribute('href');
        if (href && href !== '#' && !isImageUrl(href)) return;
      }

      var gallery = img.closest('.ark-swiper');
      var imgs = gallery
        ? Array.prototype.slice.call(gallery.querySelectorAll('img'))
        : [img];
      var i = imgs.indexOf(img);

      e.preventDefault();  // 拡大用リンクの別タブ遷移を止める
      e.stopPropagation();
      openBox(imgs.map(toItem), i < 0 ? 0 : i);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
